import { render, staticRenderFns } from "./DataShow.vue?vue&type=template&id=4e400903&scoped=true&"
import script from "./DataShow.vue?vue&type=script&lang=js&"
export * from "./DataShow.vue?vue&type=script&lang=js&"
import style0 from "./DataShow.vue?vue&type=style&index=0&id=4e400903&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e400903",
  null
  
)

export default component.exports